import { render, staticRenderFns } from "./emailButtonElementEditor.vue?vue&type=template&id=768d78e8&scoped=true&"
import script from "./emailButtonElementEditor.vue?vue&type=script&lang=js&"
export * from "./emailButtonElementEditor.vue?vue&type=script&lang=js&"
import style0 from "./emailButtonElementEditor.vue?vue&type=style&index=0&id=768d78e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d78e8",
  null
  
)

export default component.exports